'use strict';

function getInputGroup(children) {
  return {
    tag: 'div',
    attrs: {
      className: {
        'input-group': true
      }
    },
    children: children
  };
}

module.exports = getInputGroup;


/*****************
 ** WEBPACK FOOTER
 ** ./~/uvdom-bootstrap/lib/getInputGroup.js
 ** module id = 1070
 ** module chunks = 0
 **/